import {
  CREATE_BULLETIN_REQUEST,
  CREATE_BULLETIN_SUCCESS,
  CREATE_BULLETIN_FAILED,
  GET_BULLETIN_DRAFT_REQUEST,
  GET_BULLETIN_DRAFT_SUCCESS,
  GET_BULLETIN_DRAFT_FAILED,
  UPDATE_BULLETIN_DRAFT_REQUEST,
  UPDATE_BULLETIN_DRAFT_SUCCESS,
  UPDATE_BULLETIN_DRAFT_FAILED,
  CLEAR_BULLETIN_SUCCESS,
  PUBLISHED_BULLETIN_STATUS_REQUEST,
  PUBLISHED_BULLETIN_STATUS_SUCCESS,
  PUBLISHED_BULLETIN_STATUS_FAILED,
  SEARCH_BULLETIN_REQUEST,
  SEARCH_BULLETIN_SUCCESS,
  SEARCH_BULLETIN_FAILED,
  DRAFT_BULLETIN_ACTIVE_STATUS_FAILED,
  DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS,
  DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST,
  REMOVE_BULLETIN_SUCCESS,
  REMOVE_BULLETIN_FAILED,
  REMOVE_BULLETIN_REQUEST,
  PREVIEW_BULLETIN_SUCCESS,
} from "../Actions/BulletinAction";

const BulletinInitialState = {
  loading: false,
  updateLoading: false,
  success: false,
  errors: {},
  usersPerPage: 10,
  currentPage: 1,
  totalCount: 0,
  bulletinList: [],
  bulletinDetail: [],
  isEdit: false,
};

export const BulletinReducer = (state = BulletinInitialState, action) => {
  switch (action.type) {
    case CREATE_BULLETIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_BULLETIN_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletinList: action?.payload,
      };
    case CREATE_BULLETIN_FAILED:
      return {
        ...state,
        loading: false,
      };

      case PREVIEW_BULLETIN_SUCCESS:
      return {
        ...state,
        bulletinDetail: action?.payload
      };

    case GET_BULLETIN_DRAFT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BULLETIN_DRAFT_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletinDetail: action?.payload,
        totalCount: action?.payload?.total,
        isEdit: true,
      };

    case CLEAR_BULLETIN_SUCCESS: {
      return {
        ...state,
        loading: false,
        bulletinDetail: {},
        totalCount: 0,
        isEdit: false,
      };
    }

    case GET_BULLETIN_DRAFT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case UPDATE_BULLETIN_DRAFT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_BULLETIN_DRAFT_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletinDetail: action?.payload,
        totalCount: action?.payload?.total,
        isEdit: false,
      };

    case UPDATE_BULLETIN_DRAFT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case PUBLISHED_BULLETIN_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PUBLISHED_BULLETIN_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletinList: state?.bulletinList?.filter(
          (item) => item?.Id !== action?.payload?.Id
        ),
      };
    case PUBLISHED_BULLETIN_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_BULLETIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_BULLETIN_SUCCESS:
      return {
        ...state,
        bulletinList: action?.payload?.bulletin_list,
        loading: false,
        totalCount: action?.payload?.count,
      };
    case SEARCH_BULLETIN_FAILED:
      return {
        ...state,
        loading: false,
      };
    case DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletinList: state?.bulletinList?.map((item) =>
          item?.Id === action?.payload?.Id ? action?.payload : item
        ),
      };
    case DRAFT_BULLETIN_ACTIVE_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };

    case REMOVE_BULLETIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_BULLETIN_SUCCESS:
      return {
        ...state,
        bulletinList: state?.bulletinList?.filter(
          (item) => item?.Id !== action?.payload
        ),
        loading: false,
      };
    case REMOVE_BULLETIN_FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
